// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pf-table[data-v-335b527b]{width:100%}.pf-ghost-div[data-v-335b527b]{border-radius:8px!important;border:4px solid #e2eaee;background-color:#f8f8ff}.pf-no-border[data-v-335b527b]{border:none!important}.icoLink[data-v-335b527b]{color:#006185!important}.hide[data-v-335b527b]{display:none}.Program:hover .hide[data-v-335b527b]{display:inline}a[data-v-335b527b]:hover{color:#00cd00!important;text-decoration:none}", ""]);
// Exports
module.exports = exports;
